import {
  ClientRefFragment,
  ClientsQuery,
  useClientsQuery,
  withStandardListHook,
} from '@spotify/confidence-graphql';

export const useClients = withStandardListHook<
  ClientsQuery,
  ClientRefFragment,
  'clients'
>(useClientsQuery, 'clients');
